import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { redirectToLogin } from '@/services/auth-redirect'

import AppActions from '@/store/app/actions-types'
import AuthActions from '@/store/core/auth/actions-types'
import { isTokenNearExpiry } from '@/store/core/auth/token-utils'

let config = {
  headers: {
    'Content-Type': 'application/json'
  }
}

const AxiosCdp = axios.create(config)

AxiosCdp.interceptors.request.use(
  async function(config) {
    config.baseURL = store.getters['app/getSelectedCdpAppAccessUrl']()

    if (store.state.core.auth.token) {
      config.headers.common['token'] = store.state.core.auth.token
    }

    if (store.state.core.auth.token && isTokenNearExpiry(store.state.core.auth.token)) {
      try {
        await store.dispatch('core/auth/' + AuthActions.RENEW_TOKEN)
      } catch (error) {
        console.log(error)
        store.dispatch('app/' + AppActions.OPEN_APP_ERROR_MESSAGE, error.message || "Token error.")
        .then(() => {
          store
          .dispatch('core/auth/' + AuthActions.DO_LOGOUT)
          .then(() => {
            redirectToLogin()
          })
        })
      }
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

AxiosCdp.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.response) {
      if (error.response.status == 403) {
        router.push('/')
      }

      if (error.response.status == 401 && store.state.core.auth.authenticated) {
        store
          .dispatch('core/auth/' + AuthActions.DO_LOGOUT)
          .then(() => {
            redirectToLogin()
          })
      }

      if (error.response.data.message) {
        store.dispatch('app/' + AppActions.OPEN_APP_ERROR_MESSAGE, error.response.data.message)
      }
    }

    return Promise.reject(error)
  }
)

export default AxiosCdp
